import { render, staticRenderFns } from "./DataCenterTable.vue?vue&type=template&id=5c85c0f8&scoped=true"
import script from "./DataCenterTable.vue?vue&type=script&lang=js"
export * from "./DataCenterTable.vue?vue&type=script&lang=js"
import style0 from "./DataCenterTable.vue?vue&type=style&index=0&id=5c85c0f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c85c0f8",
  null
  
)

export default component.exports